import { render } from "./UsersPage.vue?vue&type=template&id=672490f6"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
script.render = render

export default script